import { Component, OnInit, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../base-error";
import { Service } from "../../../../models/service";
import { ServiceControllerService } from "../../../../services/service-controller/service-controller.service";
import { BotControllerService } from "../../../../services/role-controller/bot-controller.service";
import { Bot } from "../../../../models/bot";
import { ActivatedRoute } from "@angular/router";
import { DatabaseItemComponent } from "../database-item/database-item.component";

@Component({
  selector: "service-databases",
  templateUrl: "./service-databases.component.html",
})
export class ServiceDatabasesComponent {
}
